/**
 * Byte rate of the desktop upload-chunk MP3 stream: 128 kbps CBR. Must stay in
 * lock-step with the Rust chunk contract (`src-tauri/src/audio/chunk_contract.rs`),
 * which pins every desktop chunk-producing FFmpeg invocation to `-b:a 128k`.
 */
export const CHUNK_MP3_BYTES_PER_SEC = 16_000;

/**
 * True duration (seconds) of a desktop chunk MP3, derived from its byte size.
 * The nominal chunk interval is not the duration: a throttled timer or a stop
 * flush reading a backlog produces a far longer window. The stream is CBR, so
 * size ÷ byte-rate is accurate for every window shape.
 */
export function chunkDurationSecsFromSize(sizeBytes: number): number {
  if (!Number.isFinite(sizeBytes) || sizeBytes <= 0) {
    return 0;
  }
  return sizeBytes / CHUNK_MP3_BYTES_PER_SEC;
}
